import { _, helpers, React, ts, ui, useSelector } from '_core';

import { prepareBucketedData } from './helpers';
import { Params, WIDGET_TYPE } from './types';
import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  returns: string;
  fullScreen: boolean;
  params: Params;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, returns, fullScreen, params, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);
  const resources = useSelector((state) => state.resources);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: returns,
        },
      });
      if (response) {
        setData(response.data);
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (returns) loadData();
    return () => setData(null);
  }, [returns]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return prepareBucketedData(nestedBarChartFormat(data), params.buckets.type, params.buckets.value, resources);
  }, [data, params.buckets.type, params.buckets.value, resources]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat={params.type == WIDGET_TYPE.CORRELATION ? '#.##%' : '#.###'}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
